import $ from 'jquery';
import _ from 'underscore';
import BaseTrackingView from '../../core/baseTrackingView';
import { getStorage } from '../../../home24/helpers/storage-factory';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';
import * as commonTrackingHelper from '../../tracking/common/helper';
import { setCookie } from '../../../home24-shared/core/Utils';
import * as registry from '../../../home24/core/registry';
import * as config from '../../../home24/core/config';
import {
    setCurrencyCode as appearQueueSetCurrencyCode,
    push as appearQueuePush
} from '../../tracking/common/appearQueue';
import '../../../others/jquery.appear';

export default BaseTrackingView.extend({

    events: {
        'click a[data-gtm]': 'onDataGtmClick'
    },

    cookieCallbacks: {
        GtmOnArticleClicked: 'afterClick'
    },

    onDataGtmClick: function (event) {
        commonTrackingHelper.processGtmVariables($(event.currentTarget));
    },

    initialize: function () {
        this.bindAllEvents();
        this.cleanupGtmCookies();
    },

    /**
     * Method unset cookies created by commonTrackingHelper.processGtmVariables after request is processed
     */
    cleanupGtmCookies: function () {
        var i;
        var gtmCookieNames = config.get('tracking.gtm.cookieNames');

        for (i in gtmCookieNames) { // eslint-disable-line no-restricted-syntax
            /* istanbul ignore else */
            if (gtmCookieNames.hasOwnProperty(i)) {
                setCookie(gtmCookieNames[i], '', -1);
            }
        }
    },

    bindAllEvents: function () {
        var context = this;

        this.$('[data-gtm-bind]').each(function () {
            var $this = $(this);

            if (!$this.data('gtmBinded')) {
                context.bindEvents($this);
            }
        });
    },

    setModel: function (model) {
        this.model = model;
    },

    bindEvents: function ($element, sEvents) {

        var aEvents;
        var i;
        var sCurrentEvent;

        if (!sEvents) {
            sEvents = $element.data('gtmBind'); // eslint-disable-line no-param-reassign
        }

        if (!sEvents) {
            return false;
        }

        aEvents = sEvents.split(',');

        for (i in aEvents) { // eslint-disable-line no-restricted-syntax
            /* istanbul ignore else */
            if (aEvents.hasOwnProperty(i)) {
                sCurrentEvent = aEvents[i];

                switch (sCurrentEvent) {
                    case 'appear':
                        $element.appear($.proxy(this.onAppear, this));
                        break;

                    case 'click':
                    default:
                        $element.on('click', $.proxy(this.onClick, this));
                        break;
                }

            }
        }

        $element.attr('data-gtm-binded', true);

        return true;
    },

    getEventSource: function ($element) {
        var source = $element.data('gtmEventSource');
        var categoryName;
        var currentDataLayer = getCurrentDataLayer();

        if (!source) {
            source = $element.closest('[data-gtm-event-source]').data('gtmEventSource');
        }

        if (currentDataLayer) {
            // add category name if available
            categoryName = currentDataLayer.pageProdGroup;

            if (categoryName) {
                // ie. 'Catalog - Möbel'
                source = source + ' - ' + categoryName;
            }
        }

        return source;
    },

    /**
     * Callback method for event when article appears in a viewport (is visible)
     */
    onAppear: function (event) {
        var $currentTarget = $(event.currentTarget);
        var source = this.getEventSource($currentTarget);
        var trackingData;

        trackingData = this.getTrackingData($currentTarget);

        if (!(_.isEmpty(trackingData)) && source) {
            trackingData.list = source;
            appearQueueSetCurrencyCode(trackingData.currencyCode);
            delete trackingData.currencyCode;
            appearQueuePush(trackingData);
        }
    },

    onClick: function (event) {
        var $currentTarget = $(event.currentTarget);
        var trackingData = this.getTrackingData($currentTarget);
        var toBeStored = {
            position: trackingData.position,
            source: this.getEventSource($currentTarget)
        };

        getStorage().set('GtmOnArticleClicked', toBeStored);
    },

    getTrackingData: function ($element) {
        var sku;

        // reboot way with base64 encoded data attribute
        if ($element.data('tracking')) {
            return commonTrackingHelper.decode($element.data('tracking'));
        }

        // shop-app way with data as JSON in Registry (list-view)
        if (registry.get('listView.trackingData')) {
            sku = $element.data('sku');

            return registry.get('listView.trackingData')[sku];
        }

        // shop-app way with data as JSON in Registry (wishlist)
        if (registry.get('wishlist.trackingData')) {
            sku = $element.data('sku');

            return registry.get('wishlist.trackingData')[sku];
        }

        return false;
    },

    /**
     * Callback for BaseTracking:executeCookieCallbacks executed when user enters PDP after clicking on
     * and article
     * @param storedTrackingData
     */
    afterClick: function (storedTrackingData) {
        if (typeof window.dataLayer === 'object' && this.model) {

            var skuData = registry.get('trackingData');
            var oData = {};

            skuData = skuData[this.model.get('simpleSku')];

            if (skuData && skuData.id) {

                oData = {
                    name: skuData.name,
                    id: skuData.id,
                    price: skuData.price,
                    brand: skuData.brand,
                    category: skuData.category,
                    variant: skuData.variant,
                    dimension64: skuData.dimension64
                };

                if (storedTrackingData.position) {
                    oData.position = storedTrackingData.position;
                }

                window.dataLayer.push({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            actionField: {
                                list: storedTrackingData.source
                            },
                            products: [oData]
                        }
                    }
                });
            }
        }
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/ArticleEvents.js
 **/